import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/itemAta/alteracaoFornecedor'

class AlterarFornecedorApiClient {
	async buscarFornecedores(idItemAta) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `api/fornecedorItemAta/${idItemAta}`,
		}).build()
		return await axios.get(URL)
	}

	async buscarFiliais(idFornecedor) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `api/pessoa/${idFornecedor}/filiais`,
		}).build()
		return await axios.get(URL)
	}

	async buscarHistoricoAlterarFornecedor(idItemAta, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/historico`,
			filters: { idItemAta: idItemAta },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}

	async inserirNovoFornecedor(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/alterarFornecedor`,
		}).build()
		return await axios.put(URL, dados)
	}
}

export default new AlterarFornecedorApiClient()
